import { Component, Inject , Output, EventEmitter } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: "failure-popup",
    template: require('./failure-popup.component.html'),
    styles: [require('./failure-popup.component.less')],
})

export class FailurePopupComponent {

    constructor(
        public failurePopup: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        ) { }

    @Output() newItemEvent = new EventEmitter<string>()

    paymentFailurePopupClose(value?: any) {
        this.failurePopup.close();

        // emit event on retry
        if (value) {
            this.newItemEvent.emit(value);
        }
    }
}